
import { isAward, updateuser, add, relation } from '@/api/chunjie'
import { nowInDateBetwen, getRequest } from '@/libs/utils'
import { getview } from '@/api/jfhl.js'
import cookie from 'vux/src/tools/cookie/index.js'
import Countdown from 'vux/src/components/countdown/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'

export default {
directives: {
TransferDom
},
components: {
Popup,
Countdown,
XDialog
},
data () {
return {
data: '',
partyid: 1386,
paperInfoid: '',
lotid: '',

result: '', // 中奖结果
isaddress: '',
show1: false,
isadd: false,
obj: {
linkman: '',
phone: '',
randnum: '',
address: ''
},
countdown: {
time: 45,
value: '发送',
start: false
},
guize: false,
show2: false
}
},
mounted () {
let id = getRequest().id


},
created () {
this.view()
},
computed: {
userid () {
return this.$store.state.user.userid
},
accountid () {
return this.$store.state.user.accountid
}
},
methods: {

view () {
getview({
id: this.partyid
}).then(res => {
this.paperInfoid = res.obj.paperid
this.lotid = res.obj.lotid
this.data = res.obj
this.datatime()


})
},
clickAns () {
this.show2 = true
},
datatime () {
let _this = this
let timer = nowInDateBetwen(
this.data.signstartdate,
this.data.signenddate
)
if (timer == 0) {
this.$vux.alert.show({
content:
'活动还未开始,敬请期待' + '</br>',
onHide () {
_this.$router.push({ name: 'page_home' })
}
})
} else if (timer == -1) {
this.$vux.alert.show({
content: '活动已结束',
onHide () {
_this.$router.push({ name: 'page_home' })
}
})
}
},
fuka () {
this.$router.push({ name: 'page_myfokas' })
},

answer () {
this.$router.push({ name: 'page_list' })
},
bb () {
this.$router.push({ name: 'chunjie_form' })
},

isAwardNow () {
isAward({
lotid: this.lotid,
openid: this.userid
}).then(data => {
if (data.obj.iszhongjiang == 1) {
this.result = data.obj.item

}
})
},



































submit () {
let _this = this
if (this.obj.linkman == '') {
this.$vux.toast.text('请输入姓名！', 'middle')
return false
}
if (this.obj.address == '') {
this.$vux.toast.text('请输入地址！', 'middle')
return false
}
if (this.obj.phone == '') {
this.$vux.toast.text('请输入手机号码！', 'middle')
return false
}
if (this.obj.randnum == '') {
this.$vux.toast.text('请输入验证码！', 'middle')
return false
}
add({
partyid: this.partyid,
openid: this.userid,
linkman: this.obj.linkman,
phone: this.obj.phone,
randnum: this.obj.randnum,
address: this.obj.address
}).then(data => {
relation({
openid: this.userid,
partyuserid: data.obj.partyuserid,
lotid: this.lotid
}).then(data => {
this.show1 = false
this.$vux.alert.show({
content: '提交成功',
buttonText: '确认',
onHide () {

window.location.reload()
}
})
})
})
}
}
}
